(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Login",
            {
                url: "/Login?msg&redirect",
                component: "login",
                resolve: {
                    msg: ["$transition$", function ($transition$) { return $transition$.params().msg; }],
                    redirect: ["$transition$", function ($transition$) { return $transition$.params().redirect; }]
                },
                data: {
                    pageTitle: "Login"
                }
            });
    }]);

    app.component("login",
        {
            templateUrl: "/App/Login/login.html",
            controller: loginController,
            bindings: {
                msg: "<",
                redirect: "<"
            }
        });

    // loginController.$inject = ["AuthService", "tokenApi", "$timeout"];
    // function loginController(auth, tokenApi, $timeout) {
    loginController.$inject = ["AuthService", "figAuthSettings", "$window", "$state", "baseApiUrl"];
    function loginController(AuthService, figAuthSettings, $window, $state, baseApiUrl) {
        var $ctrl = this;

        $ctrl.logout = function () {
            AuthService.logout();
        };

        $ctrl.redirectToFigAuth = function () {
            $ctrl.isLoggingIn = true;
            AuthService.login($ctrl.redirect);
        };

        if ($ctrl.redirect || !$ctrl.msg) {
            $ctrl.redirectToFigAuth();
        }
    }

})(window.app, window.angular); // jshint ignore:line